import AccountAdminService from '@/api/admin/accountAdmin.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      totalRecords: 0,
      searchTerm: '',
    },
    types: [],
    modalConfirm: {
      type: 1,
      info: {},
      loading: true,
    },
    transactionModel: {},
  },
  getters: {
    allTransactions: state => state.table,
    transactionsModalConfirm: state => state.modalConfirm,
    getTypes: state => state.types,
    getTransactionModel: state => state.transactionModel,
  },
  actions: {
    async getTransactions({ commit }) {
      const transactions = await AccountAdminService.getTransactions()
      commit('SET_TRANSACTION_MODEL', transactions)
      commit('SET_TRANSACTIONS', transactions)
      commit('SET_TOTALRECORDS', transactions.totalRecords)
    },
    async getFilteredTransactions({ commit }, transactionWrapper) {
      const response = await AccountAdminService.getFilteredTransactions(transactionWrapper)
      commit('SET_TRANSACTION_MODEL', response)
      commit('SET_TRANSACTIONS', response)
      commit('SET_TOTALRECORDS', response.totalRecords)
    },
  },
  mutations: {
    SET_TRANSACTIONS(state, transactions) {
      state.table.rows = transactions.transactions
      state.types = transactions.types
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_TRANSACTION_MODEL(state, transactionModel) {
      state.transactionModel = transactionModel
    },
    SET_TRANSACTION_TO_APPROVE_REJECT(state, filter) {
      state.modalConfirm.type = filter.type
      state.modalConfirm.info = filter.data
      state.modalConfirm.loading = false
    },
  },
}
